import { fetchSanctionStatus } from "@services/index";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAccount } from "wagmi";

const useSanction = (
)=> {
  const { address } = useAccount();

  const { data } = useQuery({
    queryKey: ["sanctionStatus", address],
    queryFn: async () => {
      const response = await fetchSanctionStatus(address as string);
      return response;
    },
    // enabled: !!address,
    enabled: false,
    staleTime: 60_000, // 60 seconds
    initialData: undefined,
  });

  const isSanctioned = useMemo(() => {
    if (data) {
      return data.isSanctioned;
    }
  }, [data]);

  return { isSanctioned };
};

export default useSanction;
